export const ORDER_STATUS = {
  ORDERED: 'Ordered',
  COMPLETE: 'Complete',
  EXPIRED: 'Expired',
  PROCESSING: 'Processing'
}

export const PRIORITY_LEVELS = {
  STAT: 'Stat',
  ROUTINE: 'Routine'
}

export const PRIORITY_LEVEL_VALUES = {
  STAT: 'S',
  ROUTINE: 'R'
}

export const TEST_CATEGORIES = {
  HEMATOLOGY: 'Hematology',
  BIOCHEMISTRY: 'Biochemistry',
  MICROBIOLOGY: 'Microbiology',
  IMMUNOLOGY: 'Immunology',
  PATHOLOGY: 'Pathology',
  RADIOLOGY: 'Radiology',
  URINE_ANALYSIS: 'Urine Analysis',
  STOOL_ANALYSIS: 'Stool Analysis',
  MOLECULAR: 'Molecular Diagnostics',
  CYTOLOGY: 'Cytology'
}

export const SPECIMEN_TYPES = {
  BLOOD: 'Blood',
  URINE: 'Urine',
  STOOL: 'Stool',
  SPUTUM: 'Sputum',
  SWAB: 'Swab',
  TISSUE: 'Tissue',
  CSF: 'Cerebrospinal Fluid',
  ASPIRATE: 'Aspirate',
  OTHER: 'Other'
}

export const RESULT_FORMATS = {
  PDF: 'PDF',
  XML: 'XML',
  JSON: 'JSON',
  HTML: 'HTML'
}

// Result processing constants
export const RESULT_ENCODING = {
  BASE64: 'base64',
  UTF8: 'utf8',
  BINARY: 'binary'
}

export const RESULT_STATUS = {
  PENDING: 'pending',
  COMPLETE: 'complete',
  ERROR: 'error',
  PARTIAL: 'partial'
}

export const PDF_MIME_TYPE = 'application/pdf'
export const XML_MIME_TYPE = 'application/xml'

// Date formats used in lab results
export const LAB_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss'
export const DISPLAY_DATE_FORMAT = 'YYYY-MM-DD HH:mm'
export const SHORT_DATE_FORMAT = 'DD MMM YYYY'

// File naming constants
export const PDF_FILE_PREFIX = 'lab-report'
export const XML_FILE_PREFIX = 'lab-data'
export const DEFAULT_FILENAME = 'lab-results.pdf'

// Lab test templates - common test panels
export const TEST_PANELS = {
  BASIC_METABOLIC: {
    name: 'Basic Metabolic Panel',
    tests: ['Glucose', 'Sodium', 'Potassium', 'Chloride', 'CO2', 'BUN', 'Creatinine', 'Calcium']
  },
  COMPLETE_BLOOD_COUNT: {
    name: 'Complete Blood Count (CBC)',
    tests: ['WBC', 'RBC', 'Hemoglobin', 'Hematocrit', 'MCV', 'MCH', 'MCHC', 'Platelets']
  },
  LIPID_PANEL: {
    name: 'Lipid Panel',
    tests: ['Total Cholesterol', 'HDL', 'LDL', 'Triglycerides']
  },
  LIVER_FUNCTION: {
    name: 'Liver Function Tests',
    tests: ['ALT', 'AST', 'ALP', 'Total Bilirubin', 'Direct Bilirubin', 'Albumin', 'Total Protein']
  },
  THYROID_PANEL: {
    name: 'Thyroid Panel',
    tests: ['TSH', 'T3', 'T4', 'Free T3', 'Free T4']
  },
  CARDIAC_MARKERS: {
    name: 'Cardiac Markers',
    tests: ['Troponin I', 'CK-MB', 'BNP', 'D-Dimer']
  },
  RENAL_FUNCTION: {
    name: 'Renal Function Tests',
    tests: ['Creatinine', 'BUN', 'eGFR', 'Uric Acid']
  },
  ELECTROLYTES: {
    name: 'Electrolytes',
    tests: ['Sodium', 'Potassium', 'Chloride', 'Bicarbonate', 'Calcium', 'Magnesium', 'Phosphate']
  }
}

// API Endpoints (as per Ampath documentation)
export const API_ENDPOINTS = {
  // TODO: Replace with actual API endpoints from backend configuration
  AUTH: '/api/lab/auth',
  CREATE_ORDER: '/api/lab/orders/create',
  GET_ORDERS: '/api/lab/orders',
  GET_ORDER_DETAIL: '/api/lab/orders/:orderId',
  UPDATE_ORDER: '/api/lab/orders/:orderId',
  CANCEL_ORDER: '/api/lab/orders/:orderId/cancel',
  GET_RESULTS: '/api/lab/results/:orderId',
  GET_PATIENT_RESULTS: '/api/lab/results/patient/:patientId',
  GET_AVAILABLE_TESTS: '/api/lab/tests',
  GET_TEST_DETAILS: '/api/lab/tests/:testId'
}

// Error Messages
export const ERROR_MESSAGES = {
  FETCH_ORDERS_FAILED: 'Failed to fetch lab orders. Please try again.',
  CREATE_ORDER_FAILED: 'Failed to create lab order. Please check your input and try again.',
  UPDATE_ORDER_FAILED: 'Failed to update lab order. Please try again.',
  CANCEL_ORDER_FAILED: 'Failed to cancel lab order. Please try again.',
  FETCH_RESULTS_FAILED: 'Failed to fetch test results. Please try again.',
  AUTHENTICATION_FAILED: 'Authentication failed. Please check your credentials.',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  INVALID_INPUT: 'Invalid input. Please check your data and try again.'
}
